"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var React = require("react");
var button_component_1 = require("../../../../common/buttons/button_component");
var pop_up_1 = require("../../../../common/modal/pop-up");
var generic_api_calls_1 = require("../../../generic_api_calls");
var ImageCarosal_1 = require("./ImageCarosal");
var AuditAnsweIcon = function (_a) {
    var userData = _a.userData;
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    var _c = React.useState([]), imageURL = _c[0], setItems = _c[1];
    console.log(userData, 'userData');
    var openImages = function () {
        setOpen(!open);
    };
    var convertImageUrlsIntoSignedUrls = function () { return __awaiter(void 0, void 0, void 0, function () {
        var uploadedImages, _loop_1, i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    uploadedImages = [];
                    if (!userData) return [3, 5];
                    _loop_1 = function (i) {
                        var imageSignedUrl;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    imageSignedUrl = '';
                                    return [4, (0, generic_api_calls_1.fetchImnageURLFromName)(userData[i].name).then(function (res) {
                                            imageSignedUrl = res.data.data.url;
                                            uploadedImages.push(imageSignedUrl);
                                        })];
                                case 1:
                                    _b.sent();
                                    return [2];
                            }
                        });
                    };
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < userData.length)) return [3, 4];
                    return [5, _loop_1(i)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    i++;
                    return [3, 1];
                case 4:
                    console.log(uploadedImages, 'uploadedImageskjhgfd');
                    setItems(__spreadArray([], uploadedImages, true));
                    _a.label = 5;
                case 5: return [2];
            }
        });
    }); };
    React.useEffect(function () {
        convertImageUrlsIntoSignedUrls();
    }, []);
    var handleClose = function () {
        setOpen(false);
    };
    return (React.createElement("div", null,
        React.createElement(material_1.IconButton, { className: imageURL.length > 0
                ? "icon-btn"
                : "icon-btn icon-disabled", disabled: imageURL.length > 0 ? false : true, onClick: function () { return openImages(); } },
            React.createElement("span", { className: "icon-Vector" })),
        React.createElement(pop_up_1.default, { open: open, popUpSize: "popup-lg" },
            React.createElement("div", { className: "modal-header header-wrapper" },
                React.createElement("h2", { className: "heading" }, 'Display Images')),
            React.createElement("div", { className: "modal-body" },
                imageURL.length > 0 && (React.createElement(ImageCarosal_1.default, { carousalElements: imageURL })),
                React.createElement("div", { className: "modal-footer sticky-modal-footer" },
                    React.createElement("div", { className: "form-btns" },
                        React.createElement(button_component_1.default, { type: "button", buttonName: 'Cancel', color: "yellow-outline", onClickHandler: handleClose })))))));
};
exports.default = AuditAnsweIcon;
